import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, type IconName } from '../lib/icons';

export interface PlaceholderPageProps {
  titleKey: string;
  icon: IconName;
}

/**
 * Stands in for a module until its phase builds it.
 *
 * Uses the prototype's own `card` and `empty` classes, so it demonstrates the
 * ported design system rather than inventing a look that will be thrown away.
 */
export function PlaceholderPage({ titleKey, icon }: PlaceholderPageProps): ReactElement {
  const { t } = useTranslation();

  return (
    <div className="card">
      <div className="card-head">
        <h1>{t(titleKey)}</h1>
      </div>
      <div className="empty">
        <Icon name={icon} />
        <div>
          <strong>{t('not_built_yet')}</strong>
          <p>{t('phase_placeholder')}</p>
        </div>
      </div>
    </div>
  );
}
